<template>
    <div class="agreementPage">
        <div class="h3">不乱价承诺同意书</div>
        <div class="item-desc">本人已成为经销商会员，享有相关会员权益。为维护市场价格秩序、稳定统一售价。</div>
        <div class="item-desc">本人自愿作出如下承诺：</div>
        <div class="item-desc">
            <span class="item-bold">1.</span> 本人承诺在销售“爱了品牌·高奢丝滑.纤手养护装”产品时，严格遵守品牌销售价格不低于每盒<span
                class="item-bold">198</span>元标准，<span class="item-bold">不低价乱价、不变相降价、不私自改价</span>
            ，不通过赠品、优惠券、返现等方式扰乱价格体系。
        </div>
        <div class="item-desc"><span class="item-bold">2.</span> 本人接受品牌方的价格监督与核查，不泄露产品底价、定价策略等保密信息。</div>
        <div class="item-desc"><span class="item-bold">3.</span> 若本人出现乱价行为，自愿<span class="item-bold">赔偿全部损失</span> ，并
            <span class="item-bold">自愿放弃所有会员权益</span>，不作任何追偿与异议。</div>
        <div class="item-desc">本人已认真阅读并完全理解以上内容，自愿遵守，郑重承诺。</div>

    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    methods: {}
}
</script>
<style lang="less">
.agreementPage {
    background-color: #fff;
    padding: 16px;
    color: #1D293B;
    line-height: 22px;
}

.h3 {
    font-size: 20px;
    text-align: center;
    margin-bottom: 12px;
    font-weight: 600;
}

.item-desc {
    text-indent: 2em;
    line-height: 22px;
    margin-bottom: 4px;
}

.item-bold {
    font-weight: bold;
}
</style>